import TempNgoService from "../../services";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";
export default {
  namespaced: true,
  state: {
    documents: {
      required: [],
      uploaded: [],
    },
    loading: false,
    working: false,
  },
  getters: {
    documents(state) {
      return state.documents;
    },
    documentsValidated(state) {
      for (let index = 0; index < state.documents.uploaded.length; index++) {
        const element = state.documents.uploaded[index];
        if (!element.validated) return false;
      }
      var required = 0;
      state.documents.required.forEach((element) => {
        required += element.count;
      });

      if (state.documents.uploaded.length === required) {
        return true;
      }
      return false;
    },
    loading(state) {
      return state.loading;
    },
    working(state) {
      return state.working;
    },
  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload;
    },
    setWorking(state, payload) {
      state.working = payload;
    },
    setDocuments(state, payload) {
      state.documents = payload;
    },
  },
  actions: {
    async uploadDocument({ commit, dispatch }, payload) {
      this._vm.$toast({
        component: ToastificationContent,
        props: {
          title: "جاري رفع الملف ...",
          icon: "LoaderIcon",
          variant: "info",
        },
      });
      try {
        const res = await TempNgoService.uploadDocument(payload);
        dispatch("fetchDocuments");
        return Promise.resolve(res);
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء رفع الملف",
            icon: "AlertIcon",
            variant: "danger",
          },
        });
        return Promise.reject(err);
      } finally {
        commit("setWorking", false);
      }
    },
    async editDocument({ commit, dispatch }, payload) {
      console.log("payload from stores" , payload)
      this._vm.$toast({
        component: ToastificationContent,
        props: {
          title: "جاري رفع الملف ...",
          icon: "LoaderIcon",
          variant: "info",
        },
      });
      try {
        const res = await TempNgoService.editDocument(payload);
        dispatch("fetchDocuments");
        return Promise.resolve(res);
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء رفع الملف",
            icon: "AlertIcon",
            variant: "danger",
          },
        });
        return Promise.reject(err);
      } finally {
        commit("setWorking", false);
      }
    },
    async fetchDocuments({ commit }) {
      commit("setLoading", true);
      try {
        const data = await TempNgoService.fetchDocuments();
        commit("setDocuments", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async downloadFile({ commit } , payload) {
      console.log("payload" , payload)
       this._vm.$toast({
        component: ToastificationContent,
        props: {
          title: "جاري تحميل الملف ...",
          icon: "LoaderIcon",
          variant: "info",
        },
      });
      var config = {
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${localStorage.getItem(
            "accessToken",
          )}`,
        },
        responseType: "blob", // Set the response type as blob
      }
      console.log("config" , config)
      try {
        let rest = await axios.get(payload.ep,  config)

        if (rest.status >= 400 && rest.status <= 500) {
          throw rest.status
        }

        const blob = new Blob([rest.data] , { type: "application/pdf" })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `${payload.name}.docx`
        link.click()
        URL.revokeObjectURL(link.href)
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء رفع الملف",
            icon: "AlertIcon",
            variant: "danger",
          },
        });
        return Promise.reject(err)
      } finally {
      }
    },
  },
};
